import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { UserModule } from '../../modules/UserModule';
import { OrganisatieModule } from '../../modules/OrganisatieModule';
import { ValidatedForm, TextField } from '../form/ValidatedForm';
import { NotificationManager } from '../../modules/notify';
import { initialenVan } from '../../modules/merkteken';

export class Login extends Component {
    constructor(props) {
        super(props);

        this.state = { organisatie: null };
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    }

    componentDidMount() {
        OrganisatieModule.huidige()
            .then(data => { if (data.success && data.value) this.setState({ organisatie: data.value }); })
            .catch(() => { /* zonder organisatie tonen we het standaardmerk */ });
    }

    handleValidSubmit(values) {
        UserModule.login(values.username, values.password).then(data => {
            if (data.success) {
                localStorage.setItem('token', data.value);
                this.props.history.push(`/`);
            } else {
                NotificationManager.error(data.value, 3000);
            }
        }).catch(() => {
            NotificationManager.error("Er is iets fout gegaan.", 3000);
        });
    }

    render() {
        const organisatie = this.state.organisatie;
        const naam = organisatie ? (organisatie.weergavenaam || organisatie.naam) : 'Toeptoernooi';

        return (
            <div className="inlogpagina">
                {/* Het logo staat boven de kaart, op het laken: een organisatie mag een
                    licht logo hebben en dat verdwijnt op een crèmekleurig vlak. */}
                <div className="inlogmerkregel">
                    {organisatie && organisatie.logoPath
                        ? <img src={'/Images/' + organisatie.logoPath} alt={organisatie.naam} />
                        : <span className="inlogmerk" aria-hidden="true">{initialenVan(naam)}</span>}
                </div>

                <div className="inlogkaart">
                    <h1>Inloggen</h1>
                    <p className="stille-tekst">Beheer van {naam}.</p>

                    <ValidatedForm onValidSubmit={this.handleValidSubmit}>
                        <TextField label="Gebruikersnaam" type="text" name="username" required
                                   autoComplete="username" placeholder="Gebruikersnaam" />
                        <TextField label="Wachtwoord" type="password" name="password" required
                                   autoComplete="current-password" placeholder="Wachtwoord" />
                        <button className="btn btn-primary btn-lg w-100 mt-2">Inloggen</button>
                    </ValidatedForm>
                </div>

                {/* De wedstrijdleider heeft hier niets te zoeken — hij heeft geen account,
                    alleen een code. Maar zonder dit lijntje bestaat zijn pagina niet: er
                    verwees nergens iets naar, dus je moest het adres kennen. */}
                <p className="inlog-andere-weg">
                    Wedstrijdleider? <Link to="/wedstrijdleider">Vul je toegangscode in</Link>
                </p>
            </div>
        );
    }
}
